import React from 'react';
import { Button } from './ui/Button';
import { CountdownTimer } from './CountdownTimer';
import { ShieldCheckIcon, CreditCardIcon, MailIcon, LockIcon, CheckCircle2Icon } from 'lucide-react';
export function OfferSection() {
  const kitItems = ['Todo lo del Recetario de Budines', 'Recetario de budines salados', 'Ideas de glaseados y toppings', 'Tabla de conversiones de ingredientes', 'Bonus adicional de repostería', '🎂 Recetario de Tortas Caseras', '🍪 Recetario de Galletas y Alfajores'];
  return <section id="compra" className="py-20 px-4 scroll-mt-20" data-id="element-106">
      <div className="max-w-6xl mx-auto" data-id="element-107">
        <div className="text-center mb-10" data-id="element-108">
          <h2 className="text-3xl md:text-4xl font-bold mb-4 text-[#3D2B1F]" data-id="element-109">
            💰 Oferta especial
          </h2>
          <p className="text-xl text-[#6B5344] mb-2" data-id="element-110">
            Hoy puedes obtener el Recetario Digital de Budines Caseros con
            descuento especial.
          </p>
          <p className="text-lg text-[#9B8578]" data-id="element-111">
            Esta promoción es por tiempo limitado. Una vez que termine, el
            precio volverá a su valor normal.
          </p>
        </div>

        {/* Two-card grid */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-10" data-id="element-112">
          {/* LEFT CARD - Original Offer */}
          <div className="bg-white rounded-3xl p-8 md:p-10 border-2 border-[#D4850A] shadow-lg relative overflow-hidden" data-id="element-113">
            {/* Decorative elements */}
            <div className="absolute top-0 right-0 bg-red-600 text-white px-6 py-2 rounded-bl-3xl font-bold uppercase tracking-wider shadow-lg text-sm" data-id="element-114">
              Oferta Especial
            </div>

            <div className="text-center mb-8 pt-8" data-id="element-115">
              <h3 className="text-2xl font-bold mb-4 text-[#3D2B1F]" data-id="element-116">
                Recetario de Budines + Bonos
              </h3>

              {/* Social proof */}
              <p className="text-sm text-[#6B5344] mb-6 flex items-center justify-center gap-2" data-id="element-117">
                <span className="flex -space-x-1" data-id="element-118">
                  <span className="w-6 h-6 rounded-full bg-[#D4850A]/20 border-2 border-white flex items-center justify-center text-[10px]" data-id="element-119">
                    👩
                  </span>
                  <span className="w-6 h-6 rounded-full bg-[#D4850A]/20 border-2 border-white flex items-center justify-center text-[10px]" data-id="element-120">
                    👨
                  </span>
                  <span className="w-6 h-6 rounded-full bg-[#D4850A]/20 border-2 border-white flex items-center justify-center text-[10px]" data-id="element-121">
                    👩
                  </span>
                </span>
                <span data-id="element-122">+2.400 personas ya descargaron</span>
              </p>

              <div className="flex flex-col items-center justify-center mb-6" data-id="element-123">
                <span className="text-xl text-[#9B8578] line-through mb-2" data-id="element-124">
                  Precio normal: $39.990
                </span>
                <div className="flex items-start justify-center text-[#D4850A] font-extrabold" data-id="element-125">
                  <span className="text-3xl mt-2" data-id="element-126">$</span>
                  <span className="text-6xl tracking-tighter" data-id="element-127">19.990</span>
                  <span className="text-xl mt-auto mb-2 ml-2" data-id="element-128">ARS</span>
                </div>
                <span className="inline-block bg-green-100 text-green-700 text-sm font-bold px-4 py-1.5 rounded-full mt-3" data-id="element-129">
                  Ahorras $20.000 — 50% de descuento
                </span>
              </div>

              <div className="flex flex-wrap justify-center gap-3 text-[#6B5344] font-medium text-sm mb-8" data-id="element-130">
                <span className="flex items-center gap-2" data-id="element-131">
                  <CreditCardIcon className="w-4 h-4 text-[#D4850A]" data-id="element-132" /> Pago
                  único
                </span>
                <span className="flex items-center gap-2" data-id="element-133">
                  <MailIcon className="w-4 h-4 text-[#D4850A]" data-id="element-134" /> Acceso
                  inmediato
                </span>
                <span className="flex items-center gap-2" data-id="element-135">
                  <ShieldCheckIcon className="w-4 h-4 text-[#D4850A]" data-id="element-136" />{' '}
                  Garantía 45 días
                </span>
              </div>
            </div>

            <div className="text-center" data-id="element-137">
              <Button href="http://checkout.sabores365.online/cart/59169162362961:1" size="lg" className="w-full text-lg py-5 shadow-lg" data-id="element-138">
                🛒 DESCARGAR AHORA - $19.990 ARS
              </Button>

              {/* Security badges */}
              <div className="mt-4 space-y-2" data-id="element-139">
                <p className="text-xs text-[#6B5344] flex items-center justify-center gap-2" data-id="element-140">
                  <LockIcon className="w-3 h-3 text-green-600" data-id="element-141" /> Pago 100%
                  seguro con encriptación SSL
                </p>
                <div className="flex flex-wrap justify-center gap-2" data-id="element-142">
                  <span className="flex items-center gap-1 text-xs text-[#9B8578] bg-[#FEF3E2] px-2 py-1 rounded-full border border-[#E8D5C4]" data-id="element-143">
                    <CreditCardIcon className="w-3 h-3" data-id="element-144" /> Visa
                  </span>
                  <span className="flex items-center gap-1 text-xs text-[#9B8578] bg-[#FEF3E2] px-2 py-1 rounded-full border border-[#E8D5C4]" data-id="element-145">
                    <CreditCardIcon className="w-3 h-3" data-id="element-146" /> Mastercard
                  </span>
                  <span className="flex items-center gap-1 text-xs text-[#9B8578] bg-[#FEF3E2] px-2 py-1 rounded-full border border-[#E8D5C4]" data-id="element-147">
                    <CreditCardIcon className="w-3 h-3" data-id="element-148" /> MercadoPago
                  </span>
                  <span className="flex items-center gap-1 text-xs text-[#9B8578] bg-[#FEF3E2] px-2 py-1 rounded-full border border-[#E8D5C4]" data-id="element-149">
                    <ShieldCheckIcon className="w-3 h-3" data-id="element-150" /> Transferencia
                  </span>
                </div>
              </div>
            </div>
          </div>

          {/* RIGHT CARD - Kit Completo */}
          <div className="bg-gradient-to-br from-white to-[#FEF3E2] rounded-3xl p-8 md:p-10 border-4 border-[#D4850A] shadow-2xl relative overflow-hidden" data-id="element-151">
            {/* Premium badge */}
            <div className="absolute top-0 right-0 bg-gradient-to-r from-amber-500 to-[#D4850A] text-white px-6 py-2 rounded-bl-3xl font-bold uppercase tracking-wider shadow-lg text-sm" data-id="element-152">
              Mejor Valor
            </div>

            <div className="text-center mb-8 pt-8" data-id="element-153">
              <div className="inline-block bg-[#D4850A] text-white text-sm font-bold px-4 py-2 rounded-full mb-4 uppercase tracking-wider" data-id="element-154">
                Kit Completo de Repostería
              </div>

              <div className="flex flex-col items-center justify-center mb-6" data-id="element-155">
                <span className="text-xl text-[#9B8578] line-through mb-2" data-id="element-156">
                  Precio normal: $59.990
                </span>
                <div className="flex items-start justify-center text-[#D4850A] font-extrabold" data-id="element-157">
                  <span className="text-3xl mt-2" data-id="element-158">$</span>
                  <span className="text-6xl tracking-tighter" data-id="element-159">26.700</span>
                  <span className="text-xl mt-auto mb-2 ml-2" data-id="element-160">ARS</span>
                </div>
                <span className="inline-block bg-green-100 text-green-700 text-sm font-bold px-4 py-1.5 rounded-full mt-3" data-id="element-161">
                  Ahorras $33.290 — 55% de descuento
                </span>
              </div>

              {/* Kit items checklist */}
              <div className="bg-white/80 rounded-2xl p-6 mb-8 text-left" data-id="element-162">
                <ul className="space-y-3" data-id="element-163">
                  {kitItems.map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-164">
                      <CheckCircle2Icon className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" data-id="element-165" />
                      <span className="text-[#3D2B1F] font-medium" data-id="element-166">{item}</span>
                    </li>)}
                </ul>
              </div>
            </div>

            <div className="text-center" data-id="element-167">
              <Button href="https://sabores365.online/checkouts/cn/hWNAWUA3oeosdGkFZZYphpgo/es-ar?_r=AQABXukWngkgAjjRUVFEf5G5GpMg1c4n8S7Yrc01mNQ5A7s&preview_theme_id=188152905809" size="lg" className="w-full text-lg py-5 shadow-xl bg-gradient-to-r from-[#D4850A] to-amber-600 hover:from-amber-600 hover:to-[#D4850A] animate-pulse" data-id="element-168">
                🎁 DESCARGAR KIT COMPLETO — $26.700 ARS
              </Button>

              <p className="text-xs text-[#6B5344] flex items-center justify-center gap-2 mt-4" data-id="element-169">
                <LockIcon className="w-3 h-3 text-green-600" data-id="element-170" /> Pago 100% seguro
                con encriptación SSL
              </p>
            </div>
          </div>
        </div>

        {/* Countdown and trust elements - full width below both cards */}
        <div className="bg-[#FEF3E2] rounded-2xl p-6 border border-[#E8D5C4] text-center mb-8" data-id="element-171">
          <p className="text-red-500 font-bold mb-4 uppercase tracking-wider" data-id="element-172">
            La oferta termina en:
          </p>
          <CountdownTimer size="md" data-id="element-173" />
        </div>

        {/* Trust reinforcement */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-174">
          <div className="flex items-center gap-3 bg-green-50 p-3 rounded-xl" data-id="element-175">
            <CheckCircle2Icon className="w-5 h-5 text-green-600 flex-shrink-0" data-id="element-176" />
            <span className="text-sm text-green-700 font-medium" data-id="element-177">
              Garantía de 45 días o te devolvemos el dinero
            </span>
          </div>
          <div className="flex items-center gap-3 bg-green-50 p-3 rounded-xl" data-id="element-178">
            <CheckCircle2Icon className="w-5 h-5 text-green-600 flex-shrink-0" data-id="element-179" />
            <span className="text-sm text-green-700 font-medium" data-id="element-180">
              Acceso inmediato después del pago
            </span>
          </div>
          <div className="flex items-center gap-3 bg-green-50 p-3 rounded-xl" data-id="element-181">
            <CheckCircle2Icon className="w-5 h-5 text-green-600 flex-shrink-0" data-id="element-182" />
            <span className="text-sm text-green-700 font-medium" data-id="element-183">
              Bonos incluidos sin costo adicional
            </span>
          </div>
        </div>
      </div>
    </section>;
}